var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlantIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Plant_icon_svg__clip0_2002_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.631 844.059h-87.274c-61.643 0-113.083-47.048-118.571-108.44l-17.548-196.298c-5.607-62.702 43.786-116.702 106.738-116.702h146.048c62.952 0 112.345 54 106.738 116.702l-17.548 196.298c-5.488 61.392-56.94 108.44-118.571 108.44h-.012z",
    fill: "#806B4B",
    stroke: "#415849",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.274 491.821h427.44v64.119c0 43.298-35.154 78.465-78.464 78.465H364.726c-43.297 0-78.464-35.155-78.464-78.465v-64.119h.012z",
    fill: "#BE7F4D",
    stroke: "#415849",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.25 413.369H364.738c-43.334 0-78.464 35.127-78.464 78.458 0 43.331 35.13 78.458 78.464 78.458H635.25c43.335 0 78.464-35.127 78.464-78.458 0-43.331-35.129-78.458-78.464-78.458z",
    fill: "#E69251",
    stroke: "#806B4B",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.738 534.571c-23.571 0-42.75-19.178-42.75-42.75 0-23.571 19.179-42.75 42.75-42.75h270.524c23.571 0 42.75 19.179 42.75 42.75 0 23.572-19.179 42.75-42.75 42.75H364.738z",
    fill: "#806B4B",
    stroke: "#806B4B",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.738 489.5h270.524c16.262 0 30.428 9.131 37.655 22.536a42.44 42.44 0 005.095-20.215c0-23.571-19.179-42.75-42.75-42.75H364.738c-23.571 0-42.75 19.179-42.75 42.75a42.44 42.44 0 005.095 20.215c7.226-13.405 21.393-22.536 37.655-22.536z",
    fill: "#BE7F4D",
    stroke: "#806B4B",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 308.214c15.774 0 28.572 12.797 28.572 28.571v197.786h-57.143V336.785c0-15.774 12.797-28.571 28.571-28.571z",
    fill: "#46C65E",
    stroke: "#1E9561",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.845 310.726c41.298 7.417 74.048 28.298 84.953 51.524-18.298 17.988-56.262 26.178-97.572 18.774-41.297-7.417-74.047-28.298-84.952-51.524 18.298-17.988 56.262-26.179 97.571-18.774z",
    fill: "#46C65E",
    stroke: "#1E9561",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.155 310.726c-41.298 7.417-74.048 28.298-84.953 51.524 18.298 17.988 56.262 26.178 97.572 18.774 41.297-7.417 74.047-28.298 84.952-51.524-18.297-17.988-56.262-26.179-97.571-18.774z",
    fill: "#46C65E",
    stroke: "#1E9561",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.476 155.94h-93.309c11.393 19.739 8.238 44.655-7.727 60.917-13.988 14.262-22.416 33.988-21.773 55.691 1.178 39.535 33.035 71.964 72.559 73.785 43.714 2.012 79.786-32.833 79.786-76.107 0-20.667-8.226-39.417-21.595-53.143-15.977-16.416-19.393-41.297-7.941-61.143z",
    fill: "#22AB6F",
    stroke: "#17734B",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.762 155.94h-14.607c11.393 19.739 8.238 44.655-7.726 60.917-13.988 14.262-22.417 33.988-21.774 55.691.94 31.797 21.75 58.976 50.405 69.357 27.238-20.893 44.797-53.75 44.797-90.726 0-39.75-20.297-74.762-51.107-95.239h.012z",
    fill: "#22AB6F",
    stroke: "#17734B",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.512 534.571H391.488",
    stroke: "#415849",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.774 754.048c-9.679 0-25.727-7.345-36.048-17.631a17.32 17.32 0 01-2.738.226h-7.929c-.94 0-1.881-.071-2.797-.226-10.322 10.286-26.357 17.631-36.048 17.631-2.559 0-4.857-.476-6.833-1.429-5.834-2.786-8.845-9.619-10.107-22.845-.81-8.488-.762-18.869.131-27.774 1.607-16.095 5.154-20.738 8.428-23.155 2.453-1.809 5.5-2.726 9.072-2.726 9.512 0 25.321 7.417 35.523 17.81.869-.131 1.75-.203 2.643-.203h7.869c.893 0 1.762.072 2.631.203 10.203-10.393 26.012-17.81 35.524-17.81 3.571 0 6.619.917 9.06 2.726 3.273 2.417 6.833 7.06 8.44 23.167.893 8.917.929 19.309.119 27.798-1.262 13.214-4.286 20.035-10.107 22.809-1.976.941-4.274 1.429-6.833 1.429z",
    fill: "#806B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.095 685.655c1.441 0 2.619.274 3.405.857 6.667 4.917 7.369 54 0 57.512-.702.333-1.631.5-2.726.5-8.143 0-25.845-8.691-33.345-19.607a8.054 8.054 0 01-5.489 2.202h-7.869a7.716 7.716 0 01-3.059-.619 8.069 8.069 0 01-2.441-1.583c-7.488 10.916-25.202 19.607-33.345 19.607-1.107 0-2.024-.155-2.726-.5-7.357-3.524-6.655-52.595 0-57.512.798-.583 1.964-.857 3.405-.857 8.25 0 25.416 8.952 32.714 19.774a8.228 8.228 0 012.381-1.56 7.964 7.964 0 013.059-.607h7.869c2.024 0 3.965.786 5.441 2.155 7.298-10.822 24.464-19.774 32.714-19.774m-84.178-19.036c-7.024 0-11.881 2.488-14.715 4.572-7.119 5.261-10.666 13.916-12.261 29.881-.941 9.488-.989 20.559-.131 29.619 1.142 11.988 3.869 24.988 15.476 30.535 3.285 1.572 6.964 2.357 10.952 2.357 10.893 0 27.393-6.785 39.56-17.404h6.428c12.167 10.619 28.667 17.404 39.56 17.404 3.988 0 7.666-.797 10.94-2.357 11.607-5.547 14.345-18.535 15.488-30.512.869-9.059.822-20.142-.131-29.642-1.595-15.977-5.142-24.631-12.25-29.881-2.845-2.096-7.69-4.584-14.726-4.584-11.857 0-27.667 7.488-39.059 17.619h-6.06c-11.393-10.119-27.202-17.607-39.059-17.619l-.012.012z",
    fill: "#BE7F4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Plant_icon_svg__clip0_2002_339"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantIcon);
export default ForwardRef;